(() => {
  const SECTION_SELECTOR = '.mt-kj-product-carousel[data-section-id]';
  const CARD_SELECTOR = '.mt-kj-product-carousel__card';
  const SWATCH_SELECTOR = '[data-swatch]';

  const updateCardImage = (swatch) => {
    const card = swatch?.closest?.(CARD_SELECTOR);
    const image = card?.querySelector?.('[data-product-image]');
    if (!card || !image) return;

    const swatches = card.querySelectorAll(SWATCH_SELECTOR);
    swatches.forEach((item) => {
      const isSelected = item === swatch;
      item.classList.toggle('is-selected', isSelected);
      item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    if (swatch.dataset.imageSrc) {
      image.src = swatch.dataset.imageSrc;
      image.srcset = swatch.dataset.imageSrc;
    }

    if (swatch.dataset.imageAlt) {
      image.alt = swatch.dataset.imageAlt;
    }
  };

  const initSection = (section) => {
    if (!section || section.dataset.mtKjProductCarouselInitialized === 'true') {
      return;
    }

    section.dataset.mtKjProductCarouselInitialized = 'true';

    const viewport = section.querySelector('[data-carousel-viewport]');
    const carousel = section.querySelector('[data-carousel]');
    const firstMedia = section.querySelector('.mt-kj-product-carousel__media');
    const prevButton = section.querySelector('[data-carousel-prev]');
    const nextButton = section.querySelector('[data-carousel-next]');
    const isLoopEnabled = section.dataset.loopEnabled === 'true';

    const updateNavState = () => {
      if (!viewport || !prevButton || !nextButton) return;
      const maxScrollLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const current = viewport.scrollLeft;
      const hasOverflow = maxScrollLeft > 1;

      if (!hasOverflow) {
        prevButton.disabled = true;
        nextButton.disabled = true;
        return;
      }

      if (isLoopEnabled) {
        prevButton.disabled = false;
        nextButton.disabled = false;
        return;
      }

      prevButton.disabled = current <= 1;
      nextButton.disabled = current >= maxScrollLeft - 1;
    };

    const updateDesktopNavPosition = () => {
      if (!carousel || !firstMedia || window.matchMedia('(max-width: 749px)').matches) {
        section.dataset.desktopNavAligned = 'false';
        section.style.removeProperty('--mt-kj-product-carousel-desktop-nav-offset');
        return;
      }

      const carouselRect = carousel.getBoundingClientRect();
      const mediaRect = firstMedia.getBoundingClientRect();
      const navHeight = prevButton?.offsetHeight || nextButton?.offsetHeight || 0;
      const mediaCenter = mediaRect.top - carouselRect.top + mediaRect.height / 2;
      const navOffset = Math.max(0, mediaCenter - navHeight / 2);

      section.style.setProperty(
        '--mt-kj-product-carousel-desktop-nav-offset',
        `${navOffset}px`
      );
      section.dataset.desktopNavAligned = 'true';
    };

    const scrollByPage = (direction) => {
      if (!viewport) return;
      const maxScrollLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const current = viewport.scrollLeft;
      const hasOverflow = maxScrollLeft > 1;
      if (!hasOverflow) {
        updateNavState();
        return;
      }

      if (isLoopEnabled) {
        if (direction > 0 && current >= maxScrollLeft - 1) {
          viewport.scrollTo({ left: 0, behavior: 'auto' });
        } else if (direction < 0 && current <= 1) {
          viewport.scrollTo({ left: maxScrollLeft, behavior: 'auto' });
        } else {
          viewport.scrollBy({ left: viewport.clientWidth * direction, behavior: 'smooth' });
        }
      } else {
        viewport.scrollBy({ left: viewport.clientWidth * direction, behavior: 'smooth' });
      }

      window.setTimeout(updateNavState, 250);
    };

    if (prevButton && nextButton) {
      prevButton.addEventListener('click', () => scrollByPage(-1));
      nextButton.addEventListener('click', () => scrollByPage(1));
    }

    section.addEventListener('click', (event) => {
      const swatch = event.target?.closest?.(SWATCH_SELECTOR);
      if (!swatch) return;

      event.preventDefault();
      event.stopPropagation();
      updateCardImage(swatch);
    });

    section.addEventListener('keydown', (event) => {
      const swatch = event.target?.closest?.(SWATCH_SELECTOR);
      if (!swatch) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      event.stopPropagation();
      updateCardImage(swatch);
    });

    if (viewport) {
      viewport.addEventListener('scroll', updateNavState, { passive: true });
    }

    window.addEventListener('resize', () => {
      updateNavState();
      updateDesktopNavPosition();
    });
    updateNavState();
    updateDesktopNavPosition();
  };

  const initAllSections = (container = document) => {
    container.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAllSections());
  } else {
    initAllSections();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllSections(event.target);
  });
})();
